//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Page',
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
}
